<template>
  <div>
    <!-- Filter Dialog -->
    <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
      <v-card width="570px" height="100vh" class="filterDialogClass">
        <v-row class="mt-4 mx-1">
          <v-col>
            <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
              Filter
            </div>
          </v-col>
          <v-col class="d-flex justify-end">
            <div
              @click="clearFilter"
              class="clear-filter-btn"
            >
              CLEAR FILTER
            </div>
          </v-col>
        </v-row>

        <v-tabs vertical>   
          <div class="ml-3 mt-4 mr-4 filterLine">
            <v-tab key="Levels" class="black--text justify-start" active-class="activeTab">
              <span>Levels</span>
              <span v-if="selectedLevelFilter.length > 0" class="ml-1">
                ({{ selectedLevelFilter.length }})</span>
            </v-tab>
            <v-tab key="SetNumbers" class="black--text justify-start" active-class="activeTab">
              <span>Sets</span>
              <span v-if="selectedSetFilter.length > 0" class="ml-1">
                ({{ selectedSetFilter.length }})</span>
            </v-tab>
            <v-tab key="NepLevels" class="black--text justify-start" active-class="activeTab">
              <span>Nep Level</span>
              <span v-if="selectedNepLevelFilter.length > 0" class="ml-1">
                ({{ selectedNepLevelFilter.length }})</span>
            </v-tab>
            <v-tab key="ReportedQuestions" class="black--text justify-start" active-class="activeTab">
              <span>Reported Questions</span>
              <span v-if="selectedReportedQuestionsFilter" class="ml-1">(1)</span>
            </v-tab>
          </div>

        <v-tab-item key="Levels">
          <v-card>
            <v-card-text>
              <v-chip-group active-class="active-chip" v-model="selectedLevelFilter" column :multiple="true">
                <v-chip v-for="(level,index) in levelOptions" 
                :key="index"
                :value="level"
                elevated>
                  {{level}}
                </v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="SetNumbers">
          <v-card>
            <v-card-text>
              <v-chip-group active-class="active-chip" v-model="selectedSetFilter" column :multiple="true">
                <v-chip v-for="(set,index) in setNumsOptions" 
                :key="index"
                :value="set"
                elevated>
                  Set{{set}}
                </v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="NepLevels">
          <v-card>
            <v-card-text>
              <v-chip-group active-class="active-chip" v-model="selectedNepLevelFilter" column :multiple="true">
                <v-chip v-for="(nepLevel,index) in nepLevelOptions" 
                :key="index"
                :value="nepLevel"
                elevated>
                  {{nepLevel}}
                </v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="ReportedQuestions">
        <v-card flat height="580px" id="myScroll">
          <v-card-text>
            <v-chip-group v-model="selectedReportedQuestionsFilter" active-class="active-chip" column 
              :multiple="false"
              >

              <v-chip v-for="(question, index) in reportedQuestions" :key="index" :value="question.value" elevated>
              {{ question.label }}
            </v-chip>
              <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs" v-on="on" elevated active-class="active-chip">
                  Custom Dates 
                </v-chip>
              </template>
              <v-card>
                <v-card-title>Select Dates</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-menu ref="menu" v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" label="Start Date" prepend-icon="mdi-calendar" v-model="customStartDate" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="customStartDate" @input="menuStart = false" class="custom-date-picker"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-menu ref="menu" v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" label="End Date" prepend-icon="mdi-calendar" v-model="customEndDate" readonly></v-text-field>
                        </template>
                        <v-date-picker v-model="customEndDate" @input="menuEnd = false" class="custom-date-picker"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="btn primary-btn" @click="addCustomDates">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            </v-chip-group>
          </v-card-text>
        </v-card>
      </v-tab-item>
      </v-tabs>

      


        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-0">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              outlined
              class="btn outline-btn pa-4"
              @click="closeFilter"
              >Cancel</v-btn
            >
            <v-btn
              class="btn primary-btn pa-4"
              :disabled="selectedLevelFilter.length==0 && selectedSetFilter.length==0 && selectedNepLevelFilter.length==0 && !selectedReportedQuestionsFilter"
              @click="getQuestions(),getFilterCount()"
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>                
    </v-dialog>

    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
      ">
      <v-card-title class="ml-0 pl-0">
        <p class="breadcrumb-text">Psychometry</p>
        <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
      </v-card-title>
      <div class="size-menu d-flex flex-row justify-start pr-4 w-fit align-center" style="position: fixed; right: 0">
        <v-badge color="red" dot right transition="slide-x-transition" class="mr-8">
          <v-hover>
            <img @click="notificationDialog = true" class="cursor" src="../assets/bell 1.svg" />
          </v-hover>
        </v-badge>

        <div>
          <img src="../assets/avtar.png" class="rounded-xl mr-2" width="32" height="32" />
        </div>
        <div class="d-flex flex-column d-justify-evenly user-details">
          <v-card-title class="ma-0 pa-0 elipsis">
            {{ $store.state.userInfo.name }}
          </v-card-title>
          <v-card-subtitle class="ma-0 pa-0 elipsis">
            {{ $store.state.userInfo.email }}
          </v-card-subtitle>
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn width="40px" height="40px" color="primary" dark v-bind="attrs" v-on="on" icon>
              <v-icon class="">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-btn @click="logout">logout</v-btn>
        </v-menu>
      </div>
    </v-card>

    <v-container fluid class="px-8 py-0 qpad">
      <div>
        <v-row class="mt-6 justify-space-between">
          <v-col cols="3">
            <div class="text-h6 pb-1">Psychometry</div>
          </v-col>
          <v-col cols="9" class="mt-0 mb-6">
            <v-row justify="end">
              <v-text-field
                solo
                label="Search here..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                v-model="search"
                class="search-bar border-button rounded-pill mx-3"
                dense
                clearable
              ></v-text-field>
              <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
                  :class="filterCount > 0 ? 'outline-disabled-btn' : ''"
                  rounded
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  :disabled="filterCount > 0"
                >
                <v-img
                v-bind="attrs" 
                v-on="on" 
                :style="filterCount > 0 ? 'filter: grayscale(100%) opacity(50%);' :''"
                :src="require(`@/assets/svg/sort.svg`)"
                
                />              
                  <span>SORT</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item 
                  v-for="option in sortOptions" 
                  :key="option.value" 
                  @click="selectSortOption(option.value)"
                  :class="{'selected-sort-option': selectedSort === option.value}"
                >
                  <v-list-item-title>
                    {{ option.label }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
              <v-btn @click="filterDialog=true" depressed rounded outlined class="btn outline-btn mx-3 pl-4 pr-6"
                ><v-icon class="pr-2">mdi-tune</v-icon>
                <span v-if="filterCount > 0">FILTER ({{ filterCount }})</span>
                <span v-else>FILTER</span>
              </v-btn>
              <v-btn  depressed rounded outlined
                :disabled="!$store.state.role.questionBank.delete || selectedTableItems.length === 0"
                :class="$store.state.role.questionBank.delete && selectedTableItems.length > 0 ? 'outline-btn':''"
                class="btn mx-3 pl-4 pr-6"><v-icon class="pr-2">mdi-trash-can-outline</v-icon>Delete</v-btn>

              <v-btn depressed outlined rounded class="btn outline-btn mx-3" @click="downloadQuestions" :loading="loadingQuestionsToDownload"><v-icon>mdi-import
                  mdi-rotate-90</v-icon></v-btn>

              <!-- <v-btn class="accent mx-3" rounded depressed>
                                <v-icon class="pr-2">mdi-plus</v-icon> Create
                            </v-btn> -->

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="btn primary-btn mx-3 pl-4 pr-6" rounded depressed v-bind="attrs" v-on="on"
                    :disabled="!$store.state.role.questionBank.delete">
                    <v-icon class="pr-2 ">mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <v-icon>mdi-file-document-multiple </v-icon>
                      <input type="file" @change="handleFileUpload" />

                      CREATE NEW QUESTIONS IN BULK
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title @click="downloadFile" class="cursor">
                      <v-icon>mdi-book-open-variant </v-icon>
                      DOWNLOAD SAMPLE FILE
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

            </v-row>
          </v-col>
        </v-row>

        <v-data-table
          :loading="isLoading"
          v-model="selectedTableItems"
          :headers="headers"
          height="calc(100vh - 230px)"
          fixed-header
          :items="displayedQuestions"
          show-select
          :single-select="singleSelect"
          :items-per-page="options.itemsPerPage"
          :server-items-length="totalItems"
          :options.sync="options"
          item-key="id"
          @update:options="getQuestions"
          hide-default-footer
        >
        <template v-slot:loading>
          <bubble-loader/>
        </template>
        <template v-slot:no-data>
            <div class="custom-no-data">
              <p>No Data Available</p>
            </div>
          </template>
          <template v-slot:[`item.questionStatement`]="{ item }">
            <div v-html="item.questionStatement"></div>
          </template>

          <template v-slot:[`item.level`]="{ item }">
            {{ item.level }}
          </template>
          <template v-slot:[`item.setNumber`]="{ item }">
            <div class="text-center">{{item.setNumber}}</div>
          </template>
          <template v-slot:[`item.actions`]>
            <div class="d-flex flex-row">
              <img width="36px" height="36px" class="cursor" src="../assets/edit.svg" />
            </div>
          </template>
            <template v-slot:footer="{ props }">
              <table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update-options="onFooterUpdate"
              />
            </template>
        </v-data-table>
      </div>

      <!-- Uploading Bulk Questions Dialog-->
      <v-dialog max-width="600px" max-height="80vh" v-model="uploadingQuestionsDialog" center>
        <v-card class="pa-4">
          <v-row>
            <v-col cols="6" md="6">
              <v-card-title class="pa-0 ma-0">
                Uploading... {{ bulkQuestionUploadResponse.length }} /
                {{ bulkQuestionJsonData.length }}
              </v-card-title>
            </v-col>
            <v-col cols="6" md="6">
              <v-btn class="float-right" icon
                @click="uploadingQuestionsDialog = false; getQuestions();"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-data-table :headers="headersresponce" :items="bulkQuestionUploadResponse" :items-per-page="-1">
            <template v-slot:[`item.status`]="{ item }">
              <div class="d-flex flex-row ml-2">
                {{ item.status }}

                <v-icon v-if="item.status.includes('Uploaded Successfully!')" color="success">mdi-check-all</v-icon>
                <v-icon v-else color="error">mdi-alert-circle-outline</v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Papa from "papaparse";
import PsychometryController from "@/controllers/PsychometryController";
import axios from "axios"
import {debounce} from "lodash"
import AuthService from "@/services/AuthService";
import BubbleLoader from "@/components/BubbleLoader.vue";
import { format, startOfToday, startOfYesterday, startOfWeek, startOfMonth, startOfLastWeek, startOfLastMonth, endOfToday, endOfYesterday, endOfWeek, endOfMonth, endOfLastWeek, endOfLastMonth } from 'date-fns';

export default {
  data() {
    return {
      bulkQuestionJsonData: [],
      headersresponce: [
        { text: "Question Index in CSV", value: "questionIndex" },
        { text: "Status", value: "status" },
      ],
      uploadingQuestionsDialog: false,
      search: this.$route.query.search || "",
      selectedTableItems: [],
      headers: [
        { text: "Question", value: "questionStatement", sortable: false, cellClass: "auto" },
        { text: "Level", value: "level", cellClass: "w-10", sortable: false},
        { text: "Set No", value: "setNumber", cellClass: "w-10", sortable: false},
        // { text: "nep Level", value: "nepLevel", cellClass: "w-10" },
        //{ text: "Actions", value: "actions", cellClass: "w-10" },
      ],
      tableData: [],
      singleSelect: false,

      bulkQuestionUploadResponse: [],
      isLoading:true,
      filterDialog:false,
      appliedFilter:false,
      filterCount:0,
      selectedLevelFilter:[],
      selectedSetFilter:[],
      selectedNepLevelFilter:[],
      filteredArray:[],
      setNumsOptions:[],
      levelOptions:[],
      nepLevelOptions:[],
      options:{
        items: 1,
        itemsPerPage: 10,
      },
      sortCol:"questionStatement",
      sortOrder:"asc",
      totalItems: 0,
      searchedResults:[],
      selectedSort: "questionAsc", // Default selected sort option
      sortOptions: [
        { value: "questionAsc", label: "Question - Ascending (A-Z)" },
        { value: "questionDesc", label: "Question - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
      reportedQuestions: [
        { label: 'Today', value: 'today' },
        { label: 'Yesterday', value: 'yesterday' },
        { label: 'This Week', value: 'this_week' },
        { label: 'Last Week', value: 'last_week' },
        { label: 'This Month', value: 'this_month' },
        { label: 'Last Month', value: 'last_month' },
      ],
      selectedReportedQuestionsFilter: null,
      menu: false,
      menuStart: false,
      menuEnd: false,
      customStartDate: null,
      customEndDate: null,
      isCustomDate :false,
      isCustom:false,
      sendSelectedReportedQuestionsFilter:[],
      loadingQuestionsToDownload: false,
    };
  },

  computed:{
    displayedQuestions(){
      if(this.appliedFilter==true){
        if(this.appliedSearch==true){
          return this.searchedResults
        }
        else{
          return this.filteredArray
        }
      }
      else{
        if(this.appliedSearch==true){
          return this.searchedResults
        }
        else{
          return this.tableData
        }
      }
      
    }
  },

  components: {
    BubbleLoader
  },

  watch:{
    search(newValue){
      if (newValue=='' || newValue == null) {
        this.appliedSearch=false;
      }
      else{
        // console.log(newValue);
      }
      this.options.page = 1;
      this.getQuestions();
      this.updateUrlParams();
    },
  },

  methods: {
    // toggleFilterDialog(){
    //   this.filterDialog=true;
    //   this.getSets();
    //   this.getLevels();
    //   this.getNepLevel();
    // },

    async onFooterUpdate(newOptions) {
      this.options = { ...this.options, ...newOptions };
      await this.$nextTick();
      await this.getQuestions();
    },
    searchData(search){
      if(this.appliedFilter==true){
        this.searchedResults=this.filteredArray.filter((question)=>
      new RegExp(search,"i").test(question.questionStatement)
      );
      }
      else{
        this.searchedResults=this.tableData.filter((question)=>
      new RegExp(search,"i").test(question.questionStatement)
      );
      }
        this.appliedSearch=true;
        this.updateUrlParams();
    },

    closeFilter(){
      this.filterDialog=false;
    },

    clearFilter(){
      this.selectedLevelFilter=[]
      this.selectedSetFilter=[]
      this.selectedNepLevelFilter=[]
      this.filterCount = 0,
      this.appliedFilter=false
      this.selectedSort = "questionAsc";
      this.sortCol = "questionStatement";
      this.sortOrder = "asc";
      this.sendSelectedReportedQuestionsFilter = [];
      this.selectedReportedQuestionsFilter = null
      this.isCustomDate = false;
      this.filterDialog = false;
      this.getQuestions();
    },

    getFilterCount() {
      this.filterCount = 0;
      if (this.selectedLevelFilter.length > 0) {
        this.filterCount++;
      }
      if (this.selectedSetFilter.length > 0) {
        this.filterCount++;
      }
      if (this.selectedNepLevelFilter.length > 0) {
        this.filterCount++;
      }
      if(this.selectedReportedQuestionsFilter) {
        this.filterCount++;
      }
    },

    filterQuestions(selectedLevel,selectedSetNum,selectedNepLevel){
      this.filteredArray=[];
      for(const question of this.tableData){
        let levelExists=false;
        let neplevelExists=false;
        let setNumExists=false;
        if(selectedLevel.length>0){
          for (const level of selectedLevel){
            if(question.level.includes(",")){
              let levs=question.level.split(", ")
              let checker = (arr, target) => target.every(v => arr.includes(v));
              levelExists=checker(selectedLevel,levs);
            }
            if(question.level==level){
             levelExists=true;
            }
          }
        }
        else{
          levelExists=true;
        }

        if(selectedSetNum.length>0){
          for (const set of selectedSetNum){
            if(question.setNumber==set){
              setNumExists=true
            }
          }
        }
        else{
          setNumExists=true;
        }
        if(selectedNepLevel.length>0){
          for (const nepLevel of selectedNepLevel){
            if(question.nepLevel==nepLevel){
              neplevelExists=true;
            }
          }
        }
        else{
          neplevelExists=true;
        }

        if(levelExists==true && setNumExists==true && neplevelExists==true){
          this.filteredArray.push(question)
        }
    }
      // console.log(this.tableData);
      // console.log(this.filterArray);
      this.appliedFilter=true;
      this.filterDialog=false;
    },

    getLevels(){
      this.levelOptions=[];
      const levelSet= new Set();
      for(const question of this.tableData){
        if(question.level.includes(",")){
          const splitArr=question.level.split(", ");
          splitArr.forEach((val)=>{levelSet.add(val)});
        }
        else{
          levelSet.add(question.level);
        }
      } 
      levelSet.forEach((val)=>this.levelOptions.push(val));
    },
    
    getSets(){
      this.setNumsOptions=[];
      const setNumb= new Set();
      for(const question of this.tableData){
        setNumb.add(question.setNumber)
      } 
      setNumb.forEach((val)=>this.setNumsOptions.push(val))
    },

    selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "questionAsc":
          this.sortCol = "questionStatement";
          this.sortOrder = "asc";
          break;
        case "questionDesc":
          this.sortCol = "questionStatement";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "createdOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "createdOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "questionAsc";
          this.sortCol = "questionStatement";
          this.sortOrder = "asc";
      }
      this.options.page = 1;
      this.getQuestions();
    },

    getNepLevel(){
      this.nepLevelOptions=[];
      const NeplevelSet= new Set();
      for(const question of this.tableData){
        NeplevelSet.add(question.nepLevel)
      } 
      NeplevelSet.forEach((val)=>this.nepLevelOptions.push(val))
    },

    async downloadFile() {
      try {
        let templateFileName = 'Hubble STAR - Question Bank Sample File.csv'
        const response = await axios.get(`https://firebasestorage.googleapis.com/v0/b/vgos-sss-stag.appspot.com/o/question_bank%2FQuestion%20Bulk%20Upload%20Template%20-%20Sheet1.csv?alt=media&token=9b80474b-f445-48e0-be23-02b8734a7ce3 `, {
          responseType: 'blob' // Important
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', templateFileName);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error('Error downloading file:', error);
      }

    },

    skippedQuestion(id, reason) {
      console.log("reason",)
      if (reason == '') {

      }
      else {
        this.removedQuestion.push("Q" + id + ". Failed" + "->reason-> " + reason)

      }

    },
    getDateRange() {
      switch (this.selectedReportedQuestionsFilter) {
        case 'today':
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfToday(), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfToday(), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'yesterday':
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfYesterday(), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfYesterday(), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'this_week':
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'last_week':
          const lastWeekDate = new Date(new Date().setDate(new Date().getDate() - 7));
          this.sendSelectedReportedQuestionsFilter = {
          start: format(startOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
          end: format(endOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'this_month':
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfMonth(new Date()), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfMonth(new Date()), 'yyyy-MM-dd 23:59:59')
          };
          break;
        case 'last_month':
          const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
          this.sendSelectedReportedQuestionsFilter = {
            start: format(startOfMonth(lastMonthDate), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfMonth(lastMonthDate), 'yyyy-MM-dd 23:59:59')
          };
          break;
        default:
          this.sendSelectedReportedQuestionsFilter = [];
          break;
      }
    },
    async getQuestions() {
      this.tableData = [];
      this.totalItems = 0;
      this.isLoading = true;
      if(this.selectedLevelFilter.length > 0 || this.selectedSetFilter.length > 0 || this.selectedNepLevelFilter.length > 0 || this.selectedReportedQuestionsFilter) {
        this.selectedSort = "questionAsc";
        this.sortCol = "questionStatement";
        this.sortOrder = "asc";
      }
      !this.isCustomDate ? this.getDateRange() : "";
      const params = {
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        sortCol: this.sortCol,
        sortOrder: this.sortOrder,
        search: this.search,
        level: this.selectedLevelFilter.join(","),
        setNumber: this.selectedSetFilter.join(","),
        nepLevel: this.selectedNepLevelFilter.join(","),
        reportedQuestions: JSON.stringify(this.sendSelectedReportedQuestionsFilter || [])
      }
      const query = "?"+(new URLSearchParams(params).toString());
      const responce = await PsychometryController.getQuestions(query);
      this.isLoading=false;
      this.totalItems = responce.data.count;
      this.tableData = responce.data.questions
      this.filterDialog = false;
    },
    csvFileToJSON(file) {
      var contents = [];
      try {
        Papa.parse(file, {
          header: false,
          skipEmptyLines: true,
          complete: function (results) {
            this.content = results;
            this.parsed = true;
            contents = this.content.data;
            var jsonData = [];
            var removedQuestion = [];
            var headers = contents[0];
            var blankcell = false;
            for (var i = 1; i < contents.length; i++) {
              var rowData = {};
              var options = [];
              var cells = contents[i];
              // if (blankcell) {
              //   break;
              // }
              for (var j = 0; j < cells.length; j++) {
                {
                  // if (cells[j].trim().length === 0) {
                  //   if (!removedQuestion.includes(i)) {
                  //     removedQuestion.push(i);
                  //     var text = "blank cell ";
                  //     this.skippedQuestion(i, text);
                  //   }

                  //   continue;
                  // }

                  var key = headers[j];

                  key = "" + key;

                  if (
                    headers[j]?.includes("questionAssetUrl") &&
                    cells[j]?.includes("https://drive.google.com/file/")
                  ) {
                    var found = cells[j].match(/\/d\/([A-Za-z0-9-]+)/);
                    //  url.val().match( /d\/([A-Za-z0-9\-]+)/ )
                    console.log("url data here", found);
                    if (found && found[1].length) {
                      rowData[headers[j]] =
                        "https://drive.google.com/uc?export=view&id=" +
                        found[1];
                    }
                    continue;
                  }

                  if (
                    key?.includes("optionValue") &&
                    cells[j] != "NA" &&
                    cells[j] != "" &&
                    cells[j] != null &&
                    cells[j] != undefined
                  ) {
                    var optionFormate = {};
                    var f = 0;
                    while (f < 3) {
                      var tempKey
                      tempKey = headers[j];
                      tempKey = tempKey.substring(0, tempKey.length - 1);
                      optionFormate[tempKey] = cells[j].trim();
                      j++;
                      f++;
                    }
                    j--;
                    options.push(optionFormate);
                  } else {
                    rowData[key] = cells[j].trim();
                  }
                }
                if (j == cells.length - 1) {
                  rowData["questionOptions"] = options;
                }
              }
              if (i != 0) {
                if (!removedQuestion?.includes(i)) {
                  jsonData.push(rowData);
                }
              }
            }
            var msg = "Question No. ";
            removedQuestion.forEach((obj) => {
              msg = msg + obj + ",";
            });
            msg = msg + " Will not upload due to black cell or Wrong Entry";
            if (removedQuestion.length != 0) {
              var msg2 = this.removedQuestion.join("\n");
              // this.downloadTextFile(msg, "uploadReport.txt");
              this.downloadTextFile(msg2, "uploadReport.txt");
            }
            // console.log("skipped reson=>",this.removedQuestion.join(" ,"))
            console.log("json data", jsonData);
            this.bulkQuestionJsonData = jsonData.map(data=> {
              for(key in data){
                if(key == ""){                  
                  delete data[key]
                }
              }
              return data;
            });
            var index = 2;

            if (!blankcell) {
              this.bulkQuestionJsonData.forEach(async (question) => {
                try {
                  const response = await PsychometryController.createQuestion(
                    question
                  );
                  if (response.status == 200) {
                    console.log(question);
                    this.bulkQuestionUploadResponse.push({
                      questionIndex: index,
                      status: "Uploaded Successfully!",
                    });
                  } else {
                    this.bulkQuestionUploadResponse.push({
                      questionIndex: index,
                      status: "Uploaded Failed!",
                    });
                  }
                  index++;
                } catch (error) {
                  console.log(error);
                }
                // console.log(this.bulkQuestionUploadResponse);
              });
            }
          }.bind(this),
        });
      } catch (e) {
        console.error(e);
      }
      //this.createQuestionsFromBulk();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      console.log(file);
      if (file) {
        this.csvFileToJSON(file);
        this.uploadingQuestionsDialog = true;
      }
    },

    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },

    updateUrlParams() {
      const query = {};
      
      if (this.search) {
        query.search = this.search;
      }

      this.$router.replace({ 
        query: query 
      }).catch(() => {});
    },
    async getQuestionFilter() {
      const response = await PsychometryController.getQuestionsFilters();
      this.nepLevelOptions = response.data.data.nepLevels
      this.levelOptions = response.data.data.levels;
      this.setNumsOptions = response.data.data.setNumbers;
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    addCustomDates() {
      this.isCustomDate = true;
      
      if (this.customStartDate && this.customEndDate) {
        this.sendSelectedReportedQuestionsFilter = {
          start: format(new Date(this.customStartDate), 'yyyy-MM-dd 00:00:00'),
          end: format(new Date(this.customEndDate), 'yyyy-MM-dd 23:59:59')
        };
        this.menu = false;
      }
    },
    formatDate(dateString) {
      return format(new Date(dateString), 'dd/MM/yyyy');
    },
    async downloadQuestions() {
      this.loadingQuestionsToDownload = true;
      const params = {
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        sortCol: this.sortCol,
        sortOrder: this.sortOrder,
        search: this.search,
        level: this.selectedLevelFilter.join(","),
        setNumber: this.selectedSetFilter.join(","),
        nepLevel: this.selectedNepLevelFilter.join(","),
        reportedQuestions: JSON.stringify(this.sendSelectedReportedQuestionsFilter || [])
      }

      const query = "?" + (new URLSearchParams(params)).toString();
      const res = await PsychometryController.exportQuestions(
        query,
      );

      const questionsToExport = res.data.questions;
      console.log("questionsToExport====>", questionsToExport);

      const fileName = "pschometryQuestions.csv";
      const dataForDownload = [];
      const questionCount = {};

      if (res.data.isReportedQuestions) {
        let serialNo = 1;
        for (const val of questionsToExport) {
            val.questionStatement = val.questionStatement.replace(/<\/?[^>]+(>|$)/g, "");

            if (questionCount[val.questionId]) {
                questionCount[val.questionId].noOfUserReportedQuestion += 1;

                const obj = {
                    serialNo: serialNo++,
                    questionId: val.questionId,
                    testRound: '',
                    level: '',
                    nepLevel: '',
                    setNumber: '',
                    skill: '',
                    questionStatement: '',
                };

                if (Array.isArray(val.questionOptions)) {
                    val.questionOptions.forEach((option, index) => {
                        obj[`optionValue${index + 1}`] = "";
                        obj[`optionKey${index + 1}`] = "";
                    });
                }

                Object.assign(obj, {
                    noOfUserReportedQuestion: '',
                    nameOfUser: val.nameOfUser,
                    campaignName: val.campaignName,
                    reportedComment: val.reportedComment,
                    dateReported: `\t${this.formatDate(val.dateReported)}`,
                    correctAnswer: val.correctAnswer,
                });

                questionCount[`${val.questionId}-${questionCount[val.questionId].noOfUserReportedQuestion}`] = obj;
            } else {
                questionCount[val.questionId] = {
                    serialNo: serialNo++,
                    questionId: val.questionId,
                    testRound: val.testRound,
                    level: val.level,
                    skill: val.skill,
                    nepLevel: val.nepLevel,
                    setNumber: val.setNumber,
                    questionStatement: val.questionStatement.replace(/<\/?[^>]+(>|$)/g, ""),
                };

                if (Array.isArray(val.questionOptions)) {
                    val.questionOptions.forEach((option, index) => {
                        questionCount[val.questionId][`optionValue${index + 1}`] = option.optionValue
                            ? option.optionValue.replace(/<\/?[^>]+(>|$)/g, "")
                            : "";
                        questionCount[val.questionId][`optionKey${index + 1}`] = option.optionKey || "";
                    });
                }

                Object.assign(questionCount[val.questionId], {
                    noOfUserReportedQuestion: 1,
                    nameOfUser: val.nameOfUser,
                    campaignName: val.campaignName,
                    reportedComment: val.reportedComment,
                    dateReported: this.formatDate(val.dateReported),
                });
            }
        }

        for (const key in questionCount) {
            dataForDownload.push(questionCount[key]);
        }
      }

      else {
        for (const val of questionsToExport) {
          val.questionStatement = val.questionStatement.replace(/<\/?[^>]+(>|$)/g, "");
          const questionOptions = this.convertOptionsToArray(val.questionOptions);
          const obj = {
            questionId: val.id,
            level: val.level,
            skill: val.skill,
            topic: val?.topic,
            questionStatement: val.questionStatement,
          }
          for (let i = 0; i <= (val.questionOptions.length / 2) + 1; i++) {
            obj[`optionKey${i + 1}`] = questionOptions[`optionKey${i + 1}`];
            const optionValue = questionOptions[`optionValue${i + 1}`];
              if (optionValue) {
                obj[`optionValue${i + 1}`] = optionValue.replace(/<\/?[^>]+(>|$)/g, "");
              } else {
                obj[`optionValue${i + 1}`] = '';
              }
          }
          dataForDownload.push(obj);
          }
      }
      dataForDownload.forEach(obj => {
        for (const key in obj) {
          if (typeof obj[key] === 'string') {
            obj[key] = this.decodeHtmlEntities(obj[key]);
          }
        }
      });
      this.exportQuestions(dataForDownload, fileName);
    },
    async exportQuestions(csvData, fileName) {
      const csv = Papa.unparse(csvData, {
        quotes: true,  // or array of booleans
        quoteChar: '"',
        escapeChar: '"'
      });

      const bom = '\uFEFF';
      const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      this.loadingQuestionsToDownload = false;
    },
    decodeHtmlEntities(text) {
      const entities = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&nbsp;': ' ',
      };
      return text.replace(/&(amp|lt|gt|quot|#39|nbsp|#(\d+));/g, function(match, entity, dec) {
        if (entity === 'quot') return '"';
        if (entity === '#39') return "'";
        return entities[entity] || String.fromCharCode(dec);
      });
    },
    convertOptionsToArray(options) {
      let result = {};
      options?.forEach((option, index) => {
        const optionIndex = index + 1;
        result[`optionValue${optionIndex}`] = option.optionValue;
        result[`optionKey${optionIndex}`] = option.optionKey;
      });
      return result;
    },
  },
  created() {
    // this.getQuestions();
    // Apply search if it exists in URL on initial load
    this.debouncedSearch = debounce(this.getQuestions,500);
    this.getQuestionFilter();
    // if (this.search) {
    //   this.searchData(this.search);
    // }
  },
  beforeRouteUpdate(to, from, next) {
    this.search = to.query.search || "";
    next();
  }
};
</script>

<style scoped>
.v-list-item__content {
  min-height: 64px;
}

.qpad {
  padding-top: 80px !important;
}
</style>